import { render, staticRenderFns } from "./ActivityGoods.vue?vue&type=template&id=45d3a916&scoped=true"
import script from "./ActivityGoods.vue?vue&type=script&lang=js"
export * from "./ActivityGoods.vue?vue&type=script&lang=js"
import style0 from "./ActivityGoods.vue?vue&type=style&index=0&id=45d3a916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3a916",
  null
  
)

export default component.exports